
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GroupSurveyExtension, GroupSurveyExtensionUiClient, PresenceEndRequest, PresenceStartRequest } from '../../backend/backendapi';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { handleError, initClient } from '../../../api';
import Spinner from '../../util/Spinner';
import GroupSurveyExtensionStore from '../../../stores/GroupSurveyExtensionStore';

@Component({
  components: {
    Spinner,
    VueGoodTable,
  },
})
export default class PresenceStartStopButton extends Vue {
  @Prop({ required: true })
  readonly groupSurveyExtensionId!: string;
  @Prop({ required: true })
  readonly presenceId!: string | null;
  @Prop({ required: true })
  readonly userId!: string | null;
  @Prop({ required: true })
  readonly externalUserId!: string | null;
  @Prop({ required: true })
  readonly checkedIn!: boolean;

  readonly store = new GroupSurveyExtensionStore();
  saving = false;

  private readonly groupSurveyExtensionApi = initClient(GroupSurveyExtensionUiClient);

  get group(): GroupSurveyExtension | null {
    return this.store.groupSurveyExtensionsById.get(this.groupSurveyExtensionId) ?? null;
  }

  async startPresence(): Promise<void> {
    this.saving = true;
    try {
      const group = this.group;
      const res = await this.groupSurveyExtensionApi.presenceStart(
          this.groupSurveyExtensionId,
          PresenceStartRequest.fromJS({ userId: this.userId, externalUserId: this.externalUserId }));
      group?.userPresences.push(res); //update only if group in store
      this.$emit('started', res);
    } catch (err) {
      handleError(this.$toasted, this.$i18n, err);
    } finally {
      this.saving = false;
    }
  }

  async stopPresence(): Promise<void> {
    if (!this.presenceId) {
      return;
    }

    this.saving = true;
    try {
      const group = this.group;
      const presenceId = this.presenceId;
      const res = await this.groupSurveyExtensionApi.presenceEnd(this.groupSurveyExtensionId, PresenceEndRequest.fromJS({ id: presenceId }));
      if (group) { //update only if group in store
        const index = group.userPresences.findIndex(e => e.id === presenceId);
        if (index < 0) {
          group.userPresences.push(res);
        } else {
          group.userPresences.splice(index, 1, res);
        }
      }
      this.$emit('stopped', res);
    } catch (err) {
      handleError(this.$toasted, this.$i18n, err);
    } finally {
      this.saving = false;
    }
  }
}
